import {Component, inject} from '@angular/core';
import {LinkComponent} from '../common/link/link.component';
import {Router, RouterLink} from '@angular/router';
import {NgForOf, NgIf} from '@angular/common';
import {MenuToggleComponent} from '../common/menu-toggle/menu-toggle.component';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-navbar',
  imports: [
    LinkComponent,
    NgForOf,
    MenuToggleComponent,
    RouterLink,
    NgIf
  ],
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {
  router = inject(Router)
  routes = [
    {label: "Événements", path: "/events"},
    {label: "Profil amoureux", path: "/love-profile"},
    {label: "Speed dating 30 ans et +", path: "/speeddating-for-30-years-old"},
    {label: "40 ans et +", path: "/speeddating-for-40-years-old"},
    {label: "50 ans et +", path: "/speeddating-for-50-years-old"},
  ]

  isDisabled() {
    return this.router.url.includes('subscribe-v2')
  }

  protected readonly environment = environment;
}
